<template>
  <div id="pptContainer" ref="pptContainer" class="ppt pptdisablearea">
    <!--
    <el-button v-if="!$route.path.includes('/s/')" icon="el-icon-edit pst_a" circle style="z-index:5;position: absolute;left:0.5rem;;top:0.5rem;" @click="setSyncUI({ drawUrl: Fn.hashToUrl(getPage.pic || getPage.url), drawShow: true, drawText: false })"></el-button>
    -->
    <div class="slide-top-actions" v-if="!$route.path.includes('/s/')">
      <DrawBtn :isCollab="true" />
      <DrawBtn :isCollab="false" title="Notes" />
    </div>
    <div
      class="teacherppt"
      style="display: flex; align-items: center; justify-content: center"
      :class="{ 'cpa-main-white-bg': isCpaWhiteBg }"
      :style="isCpaWhiteBg ? '' : `background-image:url(${getPage.default ? '/' + getPage.default : Fn.hashToUrl(getPage?.pic || getPage?.url)})`">
      <div v-if="isCpaWhiteBg && cpaAbstractData" class="cpa-main-text" v-html="cpaAbstractData"></div>
      <img
        v-if="isCpaWhiteBg"
        src="https://r2.classcipe.com/1133b79f6353615f3c8db6cb56f032445ef2cc98"
        class="cpa-flag-banner"
        alt="CPA Question Banner"
      />
      <StudentQuestions v-if="getQuestion?.type === 'comment' && $route.path.includes('/s/')" />
      <a v-if="getQuestion?.type === 'website'" :href="getQuestion.data" target="_blank" style="position: absolute; bottom: 1rem; right: 6rem; font-size: 2rem">
        <el-tooltip class="item" effect="dark" content="Embedded website link" placement="top">
          <el-button size="medium" circle><i class="el-icon-link f_1_5"></i></el-button>
        </el-tooltip>
      </a>
      <div id="imageBg" v-if="!isCpaWhiteBg" style="position: relative" :style="imageBgStyle">
        <div v-for="(media, index) in getMaterial" :key="index">
          <div v-if="media?.url" :style="getMediaStyles(media)" @click="handleOpenDialog(media)">
            <img class="rounded-borders" />
            <div
              v-if="media.type === 'video'"
              class="absolute-center"
              style="
                background: rgba(0, 0, 0, 0.5);
                border-radius: 50%;
                width: 50px;
                height: 50px;
                display: flex;
                align-items: center;
                justify-content: center;
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
              ">
              <div
                style="
                  width: 0;
                  height: 0;
                  border-left: 12px solid white;
                  border-top: 8px solid transparent;
                  border-bottom: 8px solid transparent;
                  margin-left: 4px;
                "></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="metarialcontent" v-if="(isMaterialShow || defaultShowMeterial) && getMaterial && (teacher || isStudentPaced)">
      <div class="medialist">
        <MetarialItem v-for="rect in getMaterial" :key="rect.id" :rect="rect" :teacher="teacher" />
      </div>
      <BigMetarialItem />
    </div>
    <MediaDialog v-if="dialogVisible" :media="selectedMedia" :visible="dialogVisible" @close="dialogVisible = false" />
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import StudentQuestions from './students/studentQuestions.vue'
import MetarialItem from './drag/metarialItem.vue'
import BigMetarialItem from './drag/bigMetarialItem.vue'
import MediaDialog from './mediaDialog.vue'
import DrawBtn from './DrawBtn.vue'
export default {
  props: {
    type: {type: String, default: ''},
    teacher: {
      type: Boolean,
      default: false,
    },
    defaultShowMeterial: {
      type: Boolean,
      default: false,
    },
    widthOffset: {
      type: Number,
      default: 40,
    },
    showLogo: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(['getPage', 'getQuestion', 'isMaterialShow', 'getMaterial', 'isStudentPaced']),
    cpaAbstractData() {
      const q = this.getQuestion
      if (q) {
        const val = q.abstractData || (q.abstract && q.abstract.data) || (q.cpa && q.cpa.abstract && q.cpa.abstract.data)
        if (val) return val
      }
      const page = this.getPage
      if (page) {
        return page.abstractData || (page.abstract && page.abstract.data) || (page.cpa && page.cpa.abstract && page.cpa.abstract.data) || ''
      }
      return ''
    },
    isCpaSlide() {
      const q = this.getQuestion
      if (q) {
        if (q.hasOwnProperty('isCpa')) return !!q.isCpa
        if (q.cpa?.outcome || q.cpaOutcome || (q.cpa && q.cpa.status !== undefined)) return true
      }
      const p = this.getPage
      if (p) {
        if (p.hasOwnProperty('isCpa')) return !!p.isCpa
        if (p.cpa?.outcome || p.cpaOutcome || (p.cpa && p.cpa.status !== undefined)) return true
        const pageId = p._id || p.id
        const questions = this.$store?.state?.session?.questions || []
        const found = questions.find((item) => item.page === pageId || item.pageId === pageId || item.id === pageId || item._id === pageId)
        if (found) {
          return !!(found.isCpa || found.cpa?.outcome || found.cpaOutcome || (found.cpa && found.cpa.status !== undefined))
        }
      }
      return !!this.cpaAbstractData
    },
    hasNoPic() {
      const p = this.getPage
      return !(p && (p.pic || p.url || p.default))
    },
    isCpaWhiteBg() {
      return this.hasNoPic && this.isCpaSlide
    },
  },
  components: {
    StudentQuestions,
    MetarialItem,
    BigMetarialItem,
    MediaDialog,
    DrawBtn,
    // 'ppt-type': () => import('./common/pptType.vue')
  },
  data() {
    return {
      // width: 0,
      height: 0,
      parentHeight: 0,
      rectMediaList: [],
      hasData: false,
      containerWidth: 0,
      containerHeight: 0,
      imageBgStyle: {},
      selectedMedia: null,
      dialogVisible: false,
    }
  },
  created() {
    this.rectingDelay = null
    this.sizeDelay = null
  },
  methods: {
    ...mapActions(['setSyncUI']),
    getMediaStyles(media) {
      const el = document.getElementById('imageBg')
      let containerHeight = 0
      let containerWidth = 0
      if (el) {
        containerHeight = el.clientHeight || 0
        containerWidth = el.clientWidth || 0
      }
      if (media?.position && media?.dimensions) {
        const left = media.position.x * (containerWidth / media.slideWidth) + 'px'
        const top = media.position.y * (containerHeight / media.slideHeight) + 'px'
        const width = media.dimensions.width * (containerWidth / media.slideWidth) + 'px'
        const height = media.dimensions.height * (containerHeight / media.slideHeight) + 'px'
        return {
          position: 'absolute',
          left,
          top,
          width,
          height,
          backgroundSize: 'cover',
          cursor: 'pointer',
        }
      }
    },
    updateImageStyle() {
      const el = this.$refs.pptContainer
      console.log('Updated dimensions1', el, this.containerHeight, this.containerWidth)
      if (el) {
        this.containerWidth = el.clientWidth
        this.containerHeight = el.clientHeight
        console.log('Updated dimensions', this.containerHeight, this.containerWidth)

        if (this.containerWidth > 1029) {
          const width = (this.containerHeight * 16) / 9
          const height = this.containerHeight
          this.imageBgStyle = {
            width: `${width}px`,
            height: `${height}px`,
            objectFit: 'cover',
            aspectRatio: '16 / 9',
          }
        } else {
          const width = this.containerWidth
          const height = (this.containerWidth * 9) / 16
          this.imageBgStyle = {
            width: `${width}px`,
            height: `${height}px`,
            objectFit: 'cover',
            aspectRatio: '16 / 9',
          }
        }
      }
      return this.imageBgStyle
    },
    handleOpenDialog(media) {
      this.selectedMedia = media
      this.dialogVisible = true
    },
  },
  mounted() {
    this.height = document.documentElement.clientHeight - 110
    this.parentHeight = this.height - 76
    this.$nextTick(() => {
      this.updateImageStyle()
    })
    window.addEventListener('resize', this.updateImageStyle)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateImageStyle)
  },
}
</script>

<style scoped>
.teacherppt {
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  position: relative;
  margin: 0 auto;
  transform: translateY(-50%);
  top: 50%;
  width: 100%;
  height: 100%;
}
.ppt {
  width: 100%;
  height: 100%;
  display: flow-root;
  position: relative;
}
.pptdisablearea {
  background-color: #ffffff;
}
.slide-top-actions {
  position: absolute;
  top: 16px;
  right: 20px;
  z-index: 998;
  display: flex;
  align-items: center;
  gap: 10px;
}
.metarialcontent {
  display: flex;
  width: 100%;
  flex-direction: row;
  flex-wrap: wrap;
  height: 100%;
  overflow: hidden;
  position: absolute;
  top: 0;
  z-index: 1001;
}
.medialist {
  display: flex;
  width: 220px;
  height: 100%;
  /*overflow: scroll;*/
  overflow: auto;
  flex-direction: column;
  background-color: rgba(226, 235, 243, 1);
  align-items: center;
}
.mask {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 999;
}
.full {
  width: 100%;
  height: 100%;
  position: relative;
}
.cursor {
  cursor: pointer;
}
.leftView {
  width: 150px;
  position: absolute;
  left: 0;
  overflow-y: scroll;
}
.draw-button {
  z-index: 5;
  position: absolute;
  left: 0.5rem;
  top: 0.5rem;
  cursor: pointer;
  width: 20px;
  height: 20px;
  background-position: 10px 10px;
  background-size: 20px 20px;
  background-repeat: no-repeat;
  background-color: white;
  border-radius: 20px;
  padding: 10px;
  display: block;
  background-image: url(../assets/picture/draw.png);
}
.draw-button:hover {
  opacity: 0.8;
}
.cpa-main-white-bg {
  background-color: #ffffff !important;
  background-image: none !important;
  display: flex !important;
  align-items: center;
  justify-content: center;
  padding: 2rem 2rem calc(2rem + 60px) 2rem;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
}
.cpa-main-text {
  font-size: 1.5rem;
  line-height: 1.6;
  color: #333333;
  max-width: 90%;
  max-height: 75%;
  overflow: auto;
  text-align: center;
  word-break: break-word;
  z-index: 2;
}
.cpa-flag-banner {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: auto;
  max-height: 15%;
  object-fit: contain;
  object-position: bottom;
  pointer-events: none;
  z-index: 5;
  user-select: none;
  display: block;
}
</style>
